export default {
  getBank: state => state.bank,
  getBankName: state => state.bankName,
  getAgency: state => state.agency,
  getAccount: state => state.account,
  getWhatsapp: state => state.whatsapp,
  getClientType: state => state.clientType,
  getContractType: state => state.contractType,
  getContractModel: state => state.contractModel,
  getUuid: state => state.uuid,
  getBillingAddress: state => state.billingAddress,
  getComplements: state => state.complements,
  getProviderAddressUuid: state => state.providerAddressUuid
}
